import { useTranslation } from 'react-i18next';

interface Chapter {
  id: number;
  title: string;
  description: string;
  image: string;
  imageEn?: string;
}

interface ChapterCardProps {
  chapter: Chapter;
  checkoutUrl?: string;
}

export default function ChapterCard({ chapter, checkoutUrl }: ChapterCardProps) {
  const { t, i18n } = useTranslation();
  const coverImage = i18n.language === 'en' && chapter.imageEn ? chapter.imageEn : chapter.image;

  return (
    <div
      data-product-shop
      className="group w-full text-left bg-white rounded-2xl border border-sand/60 hover:border-terracotta/40 transition-all duration-300 flex items-stretch overflow-hidden"
    >
      <div className="w-28 md:w-32 flex-shrink-0 overflow-hidden bg-sand/30">
        <img
          src={coverImage}
          alt={t(`library.collection.${chapter.id}.title`, chapter.title)}
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="flex-1 min-w-0 p-4 md:p-5 flex flex-col">
        <h3 className="font-serif text-base md:text-lg font-bold text-[#8B6F5C] leading-snug">
          {t(`library.collection.${chapter.id}.title`, chapter.title)}
        </h3>
        <p className="font-sans text-xs md:text-sm text-[#3D2B1F] leading-relaxed mt-1">
          {t(`library.collection.${chapter.id}.description`, chapter.description)}
        </p>
        {checkoutUrl && (
          <a
            href={checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 self-start inline-flex items-center gap-1.5 bg-terracotta text-white px-4 py-2 rounded-full font-sans text-xs font-semibold hover:bg-brown transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('capitulos.buy')}
            <i className="ri-shopping-bag-3-line text-sm" />
          </a>
        )}
      </div>
    </div>
  );
}